
export function LoadingSkeleton() {
  return (
    <div className="space-y-4 w-full">
      {[...Array(3)].map((_, i) => (
        <div
          key={i}
          className="bg-gray-200 dark:bg-gray-700 animate-pulse rounded-lg p-6 h-32"
        />
      ))}
    </div>
  );
}